<template>
  <div>
    <IndexNavbar />
    <main>
      <div
        class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75"
      >
        <div
          class="absolute top-0 w-full h-full bg-center bg-cover"
          style="
            background-image: url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1267&q=80');
          "
        >
          <!-- <span
            id="blackOverlay"
            class="w-full h-full absolute opacity-75 bg-black"
          ></span> -->
        </div>
        <div class="container relative mx-auto">
          <div class="items-center flex flex-wrap">
            <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
              <div class="pr-12">
                <h1 class="text-white font-semibold text-5xl">
                  Industries We Serve
                </h1>
                <p class="mt-4 text-lg text-blueGray-200">
                 we understand that every industry faces unique challenges and opportunities. Our solutions are designed to adapt to the specific needs of each sector, ensuring innovation, efficiency, and measurable results.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pb-20 bg-blueGray-200 -mt-24">
        <div class="container mx-auto px-4">
          <div class="flex flex-wrap">
            <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
              >
                <div class="px-4 py-5 flex-auto">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400"
                  >
                    <i class="fas fa-award"></i>
                  </div>
                  <h6 class="text-xl font-semibold">Port</h6>
                  <p class="mt-2 mb-4 text-blueGray-500">
                    Ports are the lifeline of global trade, and we help modernize them with intelligent infrastructure and digital platforms.
                  </p>
                </div>
              </div>
            </div>

            <div class="w-full md:w-4/12 px-4 text-center">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
              
                >
                <div class="px-4 py-5 flex-auto">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400"
                  >
                    <i class="fas fa-retweet"></i>
                  </div>
                  <h6 class="text-xl font-semibold">Cities</h6>
                  <p class="mt-2 mb-4 text-blueGray-500">
                    Smart cities are the future of urban living, and we provide integrated solutions for mobility, energy, and public services.
                  </p>
                </div>
              </div>
            </div>

            <div class="pt-6 w-full md:w-4/12 px-4 text-center">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
              >
                <div class="px-4 py-5 flex-auto">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400"
                  >
                    <i class="fas fa-fingerprint"></i>
                  </div>
                  <h6 class="text-xl font-semibold">Railways/ Airport</h6>
                  <p class="mt-2 mb-4 text-blueGray-500">
                    We are proud to support Indian Railways with advanced digital, engineering, and automation solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="w-full md:w-12/12 px-4 text-center">
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
            >
              <div class="px-4 py-5 flex-auto">
                <p class="mt-2 mb-4 text-blueGray-500">
                  With deep engagement across the Critical Infrastructure segment, we bring strong domain understanding, industry relationships, and market insight that can significantly accelerate business development initiatives and market penetration.
                </p>
                <p class="mt-2 mb-4 text-blueGray-500">
                  Our experience spans key sectors including Ports, Airports, Railways, Smart Cities, Urban Surveillance, and other mission-critical infrastructure projects, where security, reliability, and operational continuity are of paramount importance. Over the years, we have worked closely with government bodies, infrastructure operators, technology OEMs, system integrators, and ecosystem partners, enabling us to understand the evolving requirements, procurement processes, and decision-making frameworks within these sectors.
                </p>
                <p class="mt-2 mb-4 text-blueGray-500">
                  our network and experience within the Indian critical infrastructure ecosystem allow us to facilitate meaningful engagements with key decision-makers and potential consortium partners. We believe our industry reach, consultative approach, and execution-oriented support can contribute significantly towards establishing a strong market presence and driving sustainable growth
                </p>
              </div>
            </div>

            <!-- IMAGE CARDS - SIMPLE HOVER EFFECT (Screenshot wala) -->
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-white py-16 rounded-lg shadow-xl">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
                
                <!-- Card 1 - Digital Twin -->
                <div class="rounded-2xl shadow-lg h-80 md:h-[400px] cursor-pointer bg-gray-900 hover-card">
                  <img
                    src="@/assets/img/digitaltwin.png"
                    alt="Digital Twin"
                    class="w-full h-full object-contain transition-all duration-500 group-hover:scale-110 fit"
                  />
                  <div class="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-center justify-center card-overlay">
                    <h3 class="text-white text-4xl md:text-5xl font-bold text-center drop-shadow-2xl tracking-wider card-title">Digital Twin</h3>
                  </div>
                </div>

                <!-- Card 2 - Data Center -->
                <div class="rounded-2xl shadow-lg h-80 md:h-[400px] cursor-pointer bg-gray-900 hover-card">
                  <img
                    src="@/assets/img/data-center.png"
                    alt="Data Center"
                    class="w-full h-full object-contain transition-all duration-500 group-hover:scale-110"
                  />
                  <div class="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-center justify-center card-overlay">
                    <h3 class="text-white text-4xl md:text-5xl font-bold text-center drop-shadow-2xl tracking-wider card-title">Data center -IT & Physical build</h3>
                  </div>
                </div>

                <!-- Card 3 - Perimeter Intrusion -->
                <div class="rounded-2xl shadow-lg h-80 md:h-[400px] cursor-pointer bg-gray-900 hover-card ">
                  <img
                    src="@/assets/img/ARA_security_perimeter_image.jpg"
                    alt="Perimeter Intrusion"
                    class="w-full h-full object-contain transition-all duration-500 group-hover:scale-110"
                  />
                  <div class="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-center justify-center card-overlay">
                    <h3 class="text-white text-4xl md:text-5xl font-bold text-center drop-shadow-2xl tracking-wider card-title">Perimeter Intrusion</h3>
                  </div>
                </div>

                <!-- Card 4 - Detection System -->
                <div class="rounded-2xl shadow-lg h-80 md:h-[400px] cursor-pointer bg-gray-900 hover-card">
                  <img
                    src="@/assets/img/detectionsystem.png"
                    alt="Detection System"
                    class="w-full h-full object-contain transition-all duration-500 group-hover:scale-110"
                  />
                  <div class="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-center justify-center  card-overlay">
                    <h3 class="text-white text-4xl md:text-5xl font-bold text-center drop-shadow-2xl tracking-wider card-title">Detection System</h3>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer-component />
  </div>
</template>

<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

import team1 from "@/assets/img/team-1-800x800.jpg";
import team2 from "@/assets/img/team-2-800x800.jpg";
import team3 from "@/assets/img/team-3-800x800.jpg";
import team4 from "@/assets/img/team-4-470x470.png";

export default {
  data() {
    return {
      team1,
      team2,
      team3,
      team4,
    };
  },
  components: {
    IndexNavbar,
    FooterComponent,
  },
};
</script>

<style scoped>
/* Smooth hover animations */
.group {
  transition: all 0.3s ease;
}

.group:hover {
  transform: translateY(-6px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
}

/* Image zoom on hover */
.group img {
  object-fit: contain !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .group {
    height: 300px;
  }
  
  .group h3 {
    font-size: 2rem !important;
  }
}

/* Glow effect on hover */
.group:hover::after {
  z-index: -1;
}

@keyframes glow {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* Overlay fade in */
.group .absolute.inset-0 {
  backdrop-filter: blur(2px);
}

/* Icon pulse animation on hover */
.group:hover .fa-cubes,
.group:hover .fa-server,
.group:hover .fa-shield-alt,
.group:hover .fa-radar {
  animation: pulse-icon 1.5s ease-in-out infinite;
}

@keyframes pulse-icon {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* Smooth scale for overlay content */
.group .transform {
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* Darken image on hover */
.group:hover img {
  filter: brightness(0.6) saturate(0.8);
}
</style>

<style scoped>
.hover-card {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
}

/* Image scales up and shifts up on hover */
.hover-card img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.5s ease, opacity 0.5s ease;
  background: #f0f0f0;
}

.hover-card:hover img {
  transform: translateY(-20px) scale(1.05);
  opacity: 0.8;
}

/* Overlay darkens the card */
.card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  display: flex;
  align-items: flex-end;
  padding: 20px;
  box-sizing: border-box;
}

/* Title is styled and scales/highlights on hover */
.card-title {
  color: #fff;
  font-size: 1.5rem;
  font-family: sans-serif;
  margin: 0;
  transform: translateY(10px);
  opacity: 0.8;
  transition: all 0.4s ease;
}

.hover-card:hover .card-title {
  transform: translateY(0);
  opacity: 1;
  color: #ffcc00;
  text-shadow: 0 0 10px rgba(255, 204, 0, 0.6);
}
</style>